import { FuelTypography } from '@frete.com/fuel-react';
import mobile from 'is-mobile';

import { Grid } from '~components';

import * as Styled from './LoadingSpinner.styled';

function LoadingSpinner() {
  const isMobile = mobile();

  return (
    <Styled.Container>
      <Styled.LoadingWrapper>
        <Grid container direction="column" align="center" spacing={16}>
          <Grid>
            <Styled.Ellipse />
            <Styled.Analysis />
          </Grid>
          <Grid container align="center" direction="column">
            <Grid>
              <FuelTypography
                size={isMobile ? 'heading-sm' : 'heading-md'}
                variant="bold"
              >
                Estamos analisando as informações
              </FuelTypography>
            </Grid>
            <Grid>
              <FuelTypography size="body-sm" color="neutral-default">
                Essa análise pode demorar alguns segundos
              </FuelTypography>
            </Grid>
          </Grid>
        </Grid>
      </Styled.LoadingWrapper>
    </Styled.Container>
  );
}

export default LoadingSpinner;
